import { createContext } from "react";
import { connect, Socket } from "socket.io-client";
import { SOCKET_URL } from "../config";

export const socket: Socket = connect(SOCKET_URL, { transports: ["websocket"] });
export const SocketContext = createContext<any>({});
